import React, { useState } from 'react';
import { FaSun, FaMoon, FaUser, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ currentTheme, toggleTheme }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  // console.log("Usuario en Navbar:", user);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  if (window.parent.location.pathname.includes(`/view-form/`)) {
    return null;
  }

  const handleThemeChange = () => {
    toggleTheme();
  };

  return (
    <nav className="navbar fixed top-0 left-0 right-0 z-50 bg-base-100 border-b border-base-200 shadow-md">
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        <div className="flex items-center space-x-4 ml-12">
          <img
            src={process.env.REACT_APP_LOGO_URL || '/Logo%20Yes%20BPO_Mesa%20de%20trabajo%201.png'}
            alt="Logo"
            className="h-10 h-10 object-cover"
          />
          <span className="text-xl font-bold text-base-content">
            Tu Propuesta
          </span>
        </div>

        {/* Controles del Navbar */}
        <div className="flex items-center space-x-4">
          {/* Botón para cambiar el tema */}
          <label className="swap swap-rotate btn btn-ghost btn-circle">
            {/* this hidden checkbox controls the state */}
            <input
              type="checkbox"
              onChange={handleThemeChange}
              checked={currentTheme === 'dark'}
              className="hidden"
            />

            {/* sun icon */}
            <svg
              className="swap-on h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
            </svg>

            {/* moon icon */}
            <svg
              className="swap-off h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
            </svg>
          </label>

          {/* Módulo de Perfil */}
          <div className="relative">
            <button
              onClick={() => setIsProfileOpen(!isProfileOpen)}
              className="btn btn-ghost btn-circle"
            >
              <FaUser className="text-xl" />
            </button>

            {/* Menú desplegable del perfil */}
            {isProfileOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-base-100 text-base-content rounded-lg shadow-lg border border-base-200">
                <ul className="menu menu-compact p-2">
                  <li>
                    <a
                      href="#"
                      className="flex items-center px-4 py-2 hover:bg-base-200"
                    >
                      <FaUser className="mr-2" />
                      Perfil: {user?.name || 'Usuario'}
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="flex items-center px-4 py-2 hover:bg-base-200"
                    >
                      <FaCog className="mr-2" />
                      Configuración
                    </a>
                  </li>
                  <li>
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center px-4 py-2 hover:bg-base-200"
                    >
                      <FaSignOutAlt className="mr-2" />
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
